<template>
	<CreationWizardStepHeaderWrapper v-bind="headerWrapperProps" v-on="headerWrapperListeners">
		<div class="display-flex">
			<div class="display-flex">
				<div class="pr-2"></div>
				<div class="flex-centerize">
					<h1 class="med">New Slack Addon</h1>
				</div>
			</div>
		</div>
	</CreationWizardStepHeaderWrapper>
</template>

<script>
import WizardStepMixin from '../../WizardStepMixin';
import props from './SlackNativeSettings.props';
export default {
	name: 'CreatePortalHeader',
	mixins: [WizardStepMixin],
	props,
};
</script>

<style scoped lang="scss"></style>
